import { jsx as _jsx } from "react/jsx-runtime";
import ActionMenu from '../../../components/ActionMenu';
import styles from './Products.module.scss';
import { formatCurrency } from '@src/utils/formatters';
export const getProductColumns = (handleView, handleEdit, handleDelete) => [
    {
        key: 'title',
        header: 'Product Name',
        accessor: 'title',
        render: (product) => product.title,
    },
    {
        key: 'manufacturer',
        header: 'MFR',
        accessor: 'manufacturer',
        render: (product) => product.manufacturer || 'N/A',
    },
    {
        key: 'sku',
        header: 'SKU',
        accessor: 'sku',
        render: (product) => product.sku,
    },
    {
        key: 'price',
        header: 'ET RET',
        accessor: 'price',
        render: (product) => (_jsx("div", { className: styles.clickableCell, onClick: () => handleView(product), children: formatCurrency(product.price || 0) })),
    },
    {
        key: 'manufacturerRetailPrice',
        header: 'MFR RET',
        accessor: 'manufacturerRetailPrice',
        render: (product) => (_jsx("div", { className: styles.clickableCell, onClick: () => handleView(product), children: product.manufacturerRetailPrice
                ? formatCurrency(product.manufacturerRetailPrice)
                : 'N/A' })),
    },
    {
        key: 'shippingAmount',
        header: 'SHIP',
        accessor: 'shippingAmount',
        render: (product) => {
            // Nullish check, not truthiness: a configured $0.00 means "explicitly free, do
            // not fall back to the manufacturer default" and must render as $0.00, not N/A.
            const raw = product.shippingAmount ?? product.shipping_amount;
            return (_jsx("div", { className: styles.clickableCell, onClick: () => handleView(product), children: raw === null || raw === undefined ? 'N/A' : formatCurrency(raw) }));
        },
    },
    {
        key: 'action',
        header: 'Action',
        render: (product) => (_jsx("div", { onClick: (e) => e.stopPropagation(), children: _jsx(ActionMenu, { options: [
                    {
                        label: 'View Details',
                        onClick: () => handleView(product),
                    },
                    {
                        label: 'Edit Product',
                        onClick: () => handleEdit(product),
                    },
                    {
                        label: 'Delete Product',
                        onClick: () => handleDelete(product),
                        color: 'red',
                    },
                ] }) })),
    },
];
